(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hp-card-facts"] && !Shopify.designMode) return;
  try {
    (() => {
  const update = card => {
    const select = card.querySelector('[data-variant-select]');
    const target = card.querySelector('[data-hp-price-current]');
    if (!select || !target) return;
    const template = [...card.querySelectorAll('template[data-hp-price-option]')].find(item => item.dataset.hpPriceOption === select.value);
    if (template) target.replaceChildren(template.content.cloneNode(true));
  };
  const initialize = () => document.querySelectorAll('[data-product-card]').forEach(update);
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-variant-select]')) return;
    const card = event.target.closest('[data-product-card]');
    if (card) update(card);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
